import { render } from "./SocialSide.vue?vue&type=template&id=3d95f5aa"
import script from "./SocialSide.vue?vue&type=script&lang=js"
export * from "./SocialSide.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Alison\\Documents\\Dev\\Apps\\av2-portfolio-v3\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__